import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const dealsCategoryService = {
  getAllCategories,
  addCategory,
  getCategory,
  deleteCategory
};

function getAllCategories(params) {
  return apiCall("GET", apiUrls.deals.categories, null, params);
}

function addCategory(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.deals.categories;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getCategory(id) {
  return apiCall("GET", `${apiUrls.deals.categories}/${id}`);
}

function deleteCategory(id) {
  return apiCall("DELETE", `${apiUrls.deals.categories}/${id}`);
}
